/* Minimal home.
   Home grid: one tile per product line.
   - A line with several colourways opens a grid of those colourways (same layout).
   - A colourway (or a single-product line) opens the product view.
   Product view: up/down = photos (then next product), left/right = colourways (then next line). */
(function () {
  var SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', '3XL', '4XL'];
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MIN_SPIN = 600, HOLD = 1800;

  /* Safety Shades parts (same codes the product page uses in cart properties) */
  var TIP = { black: ['Black', '#151515'], grey: ['Grey', '#b9b9b9'], dblue: ['Dark Blue', '#1a2ad8'], green: ['Green', '#2fd84a'], lblue: ['Light Blue', '#5fd3f0'], orange: ['Orange', '#ff6a00'], red: ['Red', '#e01616'], pink: ['Pink', '#f59fdb'] };
  var NOSE = { black: ['Black', '#151515'], white: ['White', '#ffffff'], red: ['Red', '#e01616'], orange: ['Orange', '#ff6a00'], pink: ['Pink', '#f59fdb'], darkblue: ['Dark Blue', '#1a2ad8'], lightblue: ['Light Blue', '#5fd3f0'] };
  function arm(code) {
    var base = code.indexOf('clear') === 0 ? 'clear' : 'black';
    var t = TIP[code.slice(base.length)] || [code.slice(base.length), '#999'];
    var label = code === 'blackblack' ? 'All Black' : (base === 'clear' ? 'Clear' : 'Black') + ' / ' + t[0];
    var fill = base === 'clear' ? '#e6ecee' : '#151515';
    return { label: label, bg: 'linear-gradient(135deg, ' + fill + ' 0 55%, ' + t[1] + ' 55%)' };
  }
  function nose(code) { var n = NOSE[code] || [code, '#999']; return { label: n[0], bg: n[1] }; }
  function list(s) { return String(s || '').split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function shortName(t) { var i = String(t).indexOf(' // '); return i > -1 ? t.slice(i + 4) : t; }

  function init(root) {
    if (root._mh) return;
    root._mh = true;
    var data;
    try { data = JSON.parse(root.querySelector('[data-mh-data]').textContent); } catch (e) { return; }
    data.forEach(function (l) { l.products = l.products || []; });
    if (!data.some(function (l) { return l.products.length; })) return;
    function stepLine(from, step) {
      var n = data.length, i = from;
      do { i = (i + step + n) % n; } while (!data[i].products.length && i !== from);
      return i;
    }
    function multi(i) { return data[i] && data[i].products.length > 1; }

    var $ = function (s) { return root.querySelector(s); };
    var grid = $('[data-mh-grid]'), sub = $('[data-mh-sub]'), subGrid = $('[data-mh-subgrid]'), subTitle = $('[data-mh-subtitle]');
    var view = $('[data-mh-view]'), stage = $('[data-mh-stage]');
    var info = $('.mh__info'), titleEl = $('[data-mh-title]'), priceEl = $('[data-mh-price]');
    var sizesEl = $('[data-mh-sizes]'), addBtn = $('[data-mh-add]'), msgEl = $('[data-mh-msg]');
    var infoBtn = $('[data-mh-info-toggle]'), descEl = $('[data-mh-desc]'), closeBtn = $('[data-mh-close]');
    var customBtn = $('[data-mh-custom-toggle]'), customEl = $('[data-mh-custom]');

    var noses = list(root.dataset.noses), arms = list(root.dataset.arms), armsOk = list(root.dataset.armsOk);
    if (!armsOk.length) armsOk = arms.slice();
    function armOk(c) { return armsOk.indexOf(c) > -1; }
    var firstArm = arms.filter(armOk)[0] || arms[0] || 'blackblack';
    var pick = { nose: noses[0] || 'black', L: firstArm, R: firstArm };
    var clipRow = $('[data-mh-clip]'), clipInput = $('[data-mh-clip-input]'), clip = null;
    try { clip = JSON.parse($('[data-mh-clip-data]').textContent); } catch (e) { clip = null; }
    var armSide = 'both';

    /* mode: 'home' | 'line' | 'product' */
    var mode = 'home', L = 0, idx = 0, photo = 0, size = null, busy = false;

    /* one title size for every product: the largest that keeps the longest name on one line */
    var TITLE_MAX = 28, TITLE_MIN = 13;
    function fitTitles() {
      var avail = Math.min(root.clientWidth || window.innerWidth, 760) - 32;
      if (avail <= 0) return;
      var cs = getComputedStyle(titleEl);
      var probe = document.createElement('span');
      probe.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap;left:-9999px;top:0;font-size:100px;text-transform:uppercase;letter-spacing:0.01em;font-family:' + cs.fontFamily + ';font-weight:' + cs.fontWeight + ';font-style:' + cs.fontStyle;
      document.body.appendChild(probe);
      var widest = 1;
      data.forEach(function (l) { l.products.forEach(function (p) { probe.textContent = p.title; widest = Math.max(widest, probe.getBoundingClientRect().width); }); });
      probe.remove();
      var size = Math.max(TITLE_MIN, Math.min(TITLE_MAX, Math.floor(100 * avail / widest * 0.97)));
      root.style.setProperty('--mh-title', size + 'px');
    }
    fitTitles();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitTitles);
    var fitT = 0;
    window.addEventListener('resize', function () { clearTimeout(fitT); fitT = setTimeout(fitTitles, 120); });

    function headerOffset() {
      var h = document.querySelector('.section-header');
      root.style.setProperty('--mh-top', (h ? h.offsetHeight : 90) + 'px');
    }
    headerOffset();
    window.addEventListener('resize', headerOffset);

    function line() { return data[L]; }
    function product() { return line().products[idx]; }
    function photos(p) { p = p || product(); return p.images && p.images.length ? p.images : []; }

    /* ---------- screens ---------- */
    function fadeIn(el) {
      if (reduce) return;
      el.classList.remove('is-in');
      void el.offsetWidth;
      el.classList.add('is-in');
    }
    function showOnly(which) {
      grid.hidden = which !== 'home';
      sub.hidden = which !== 'line';
      view.hidden = which !== 'product';
      mode = which;
    }
    function setUrl(params, push) {
      var u = new URL(location.href);
      u.searchParams.delete('line'); u.searchParams.delete('item');
      if (params.line) u.searchParams.set('line', params.line);
      if (params.item) u.searchParams.set('item', params.item);
      var s = { mh: true };
      if (push) history.pushState(s, '', u); else history.replaceState(s, '', u);
    }
    function lineIndex(handle) {
      for (var i = 0; i < data.length; i++) if (data[i].handle === handle) return i;
      return -1;
    }

    function showHome(focusLine) {
      showOnly('home');
      fadeIn(grid);
      var t = focusLine != null && grid.querySelector('[data-mh-open="' + focusLine + '"]');
      if (t) t.focus({ preventScroll: true });
    }

    function showLine(i, focusIdx) {
      L = i;
      var l = line();
      subTitle.textContent = l.title || '';
      subGrid.innerHTML = l.products.map(function (p, k) {
        return '<button type="button" class="mh__tile' + (p.available ? '' : ' is-out') + '" data-mh-item="' + k + '" aria-label="' + esc(p.title + ', ' + (p.available ? p.price : 'sold out')) + '">' +
          '<span class="mh__tile-img"><img src="' + esc(p.thumb) + '" alt="" width="500" height="500" loading="' + (k < 6 ? 'eager' : 'lazy') + '"></span>' +
          '<span class="mh__tile-name">' + esc(shortName(p.title)) + '</span>' +
          '<span class="mh__tile-price">' + esc(p.price) + '</span></button>';
      }).join('');
      showOnly('line');
      window.scrollTo(0, 0);
      fadeIn(sub);
      var t = focusIdx != null ? subGrid.querySelector('[data-mh-item="' + focusIdx + '"]') : null;
      (t || $('[data-mh-back]')).focus({ preventScroll: true });
    }

    /* ---------- picture ---------- */
    function showPic(dir) {
      var srcs = photos();
      var src = srcs[photo] || srcs[0];
      var old = stage.querySelectorAll('.mh__pic');
      var im = document.createElement('img');
      im.className = 'mh__pic' + (/\.png/i.test(src || '') ? '' : ' is-photo');
      im.alt = product().title + (photo ? ', photo ' + (photo + 1) + ' of ' + srcs.length : '');
      im.decoding = 'async';
      if (src) im.src = src;
      if (dir && !reduce) im.classList.add('in-' + dir);
      stage.appendChild(im);
      old.forEach(function (o) {
        if (!dir || reduce) { o.remove(); return; }
        o.classList.remove('in-up', 'in-down', 'in-left', 'in-right');
        o.classList.add('out-' + dir);
        setTimeout(function () { o.remove(); }, 420);
      });
      stage.classList.toggle('is-soldout', !product().available);
      preload();
      return im;
    }
    function preload() {
      [neighbour('down'), neighbour('right')].forEach(function (s) {
        var p = data[s.L].products[s.idx], src = photos(p)[s.photo];
        if (src) { var i = new Image(); i.src = src; }
      });
    }

    /* where each arrow leads from the current spot */
    function neighbour(dir) {
      var s = { L: L, idx: idx, photo: photo };
      var prods = line().products;
      if (dir === 'down') {
        if (photo < photos().length - 1) { s.photo++; return s; }
        s.photo = 0;
        if (idx < prods.length - 1) { s.idx++; return s; }
        s.L = stepLine(L, 1); s.idx = 0; return s;
      }
      if (dir === 'up') {
        if (photo > 0) { s.photo--; return s; }
        if (idx > 0) { s.idx--; }
        else { s.L = stepLine(L, -1); s.idx = data[s.L].products.length - 1; }
        s.photo = Math.max(0, photos(data[s.L].products[s.idx]).length - 1);
        return s;
      }
      s.photo = 0;
      if (dir === 'right') {
        if (idx < prods.length - 1) { s.idx++; return s; }
        s.L = stepLine(L, 1); s.idx = 0; return s;
      }
      if (idx > 0) { s.idx--; return s; }
      s.L = stepLine(L, -1); s.idx = data[s.L].products.length - 1; return s;
    }

    function go(dir) {
      if (mode !== 'product' || busy) return;
      var s = neighbour(dir);
      var changed = s.L !== L || s.idx !== idx;
      L = s.L; idx = s.idx; photo = s.photo;
      showPic(dir);
      if (changed) { renderInfo(true); setUrl({ line: line().handle, item: product().handle }, false); }
      busy = true;
      setTimeout(function () { busy = false; }, reduce ? 0 : 260);
    }

    /* ---------- info ---------- */
    function sortSizes(vs) {
      return vs.slice().sort(function (a, b) {
        var ia = SIZE_ORDER.indexOf(String(a.title).toUpperCase());
        var ib = SIZE_ORDER.indexOf(String(b.title).toUpperCase());
        return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
      });
    }
    function renderInfo(animate) {
      var p = product();
      if (animate && !reduce) { info.classList.remove('is-swap'); void info.offsetWidth; info.classList.add('is-swap'); }
      titleEl.textContent = p.title;
      priceEl.textContent = p.price;
      msgEl.textContent = '';
      resetAdd();

      size = null;
      sizesEl.innerHTML = '';
      if (p.sized) {
        sortSizes(p.variants).forEach(function (v) {
          var b = document.createElement('button');
          b.type = 'button';
          b.textContent = v.title;
          b.setAttribute('role', 'radio');
          b.setAttribute('aria-checked', 'false');
          if (!v.available) { b.disabled = true; b.setAttribute('aria-label', v.title + ', sold out'); }
          b.addEventListener('click', function () {
            size = v;
            sizesEl.querySelectorAll('button').forEach(function (o) { o.setAttribute('aria-checked', o === b ? 'true' : 'false'); });
            priceEl.textContent = v.price;
            msgEl.textContent = '';
          });
          sizesEl.appendChild(b);
        });
        sizesEl.hidden = false;
      } else {
        sizesEl.hidden = true;
      }

      addBtn.classList.toggle('is-out', !p.available);
      addBtn.setAttribute('aria-label', p.available ? 'Add ' + p.title + ' to cart' : p.title + ' is sold out');
      addBtn.setAttribute('aria-disabled', p.available ? 'false' : 'true');

      if (clipRow) clipRow.hidden = !(line().clip && clip && clip.available);
      var canCustom = !!line().custom && noses.length && arms.length;
      customBtn.hidden = !canCustom;
      customEl.hidden = !canCustom || customBtn.getAttribute('aria-expanded') !== 'true';

      var asm = line().assembly && root.dataset.asm
        ? '<p class="mh__asm">Some assembly required. <a href="' + esc(root.dataset.asm) + '">Assembly tutorial &rarr;</a></p>'
        : '';
      var desc = (p.desc || '') + asm;
      descEl.innerHTML = desc;
      infoBtn.hidden = !desc;
      descEl.hidden = infoBtn.getAttribute('aria-expanded') !== 'true' || !desc;
    }

    /* ---------- customize (Safety Shades) ---------- */
    function buildDots(key, codes, infoFn) {
      var box = root.querySelector('[data-mh-dots="' + key + '"]');
      box.innerHTML = '';
      codes.forEach(function (c) {
        var d = infoFn(c);
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'mh__dot';
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-label', d.label);
        b.dataset.code = c;
        b.innerHTML = '<i style="background:' + d.bg + '"></i>';
        if (key !== 'nose' && !armOk(c)) {
          b.disabled = true;
          b.classList.add('is-out');
          b.setAttribute('aria-label', d.label + ', sold out');
        }
        b.addEventListener('click', function () {
          if (key === 'arms') {
            if (armSide === 'both') { pick.L = c; pick.R = c; }
            else pick[armSide] = c;
          } else {
            pick[key] = c;
          }
          syncDots();
        });
        box.appendChild(b);
      });
    }
    function syncDots() {
      root.querySelectorAll('[data-mh-dots="nose"] .mh__dot').forEach(function (b) {
        b.setAttribute('aria-checked', b.dataset.code === pick.nose ? 'true' : 'false');
      });
      root.querySelector('[data-mh-pick="nose"]').textContent = nose(pick.nose).label;

      var same = pick.L === pick.R;
      root.querySelectorAll('[data-mh-dots="arms"] .mh__dot').forEach(function (b) {
        var c = b.dataset.code, isL = c === pick.L, isR = c === pick.R;
        b.setAttribute('aria-checked', isL || isR ? 'true' : 'false');
        var tag = b.querySelector('.mh__tag');
        var txt = same || !(isL || isR) ? '' : (isL ? 'L' : 'R');
        if (txt) { if (!tag) { tag = document.createElement('b'); tag.className = 'mh__tag'; tag.setAttribute('aria-hidden', 'true'); b.appendChild(tag); } tag.textContent = txt; }
        else if (tag) tag.remove();
        var base = arm(c).label;
        b.setAttribute('aria-label', base + (b.disabled ? ', sold out' : '') + (isL && isR ? ', both arms' : isL ? ', left arm' : isR ? ', right arm' : ''));
      });
      root.querySelector('[data-mh-pick="arms"]').textContent = same ? arm(pick.L).label : 'L ' + arm(pick.L).label + ' · R ' + arm(pick.R).label;
      var prev = root.querySelector('[data-mh-arm-preview]');
      if (prev) prev.style.background = 'linear-gradient(90deg, ' + armColour(pick.L) + ' 0 50%, ' + armColour(pick.R) + ' 50%)';
      root.querySelectorAll('[data-mh-side]').forEach(function (s) { s.setAttribute('aria-pressed', s.dataset.mhSide === armSide ? 'true' : 'false'); });
    }
    function armColour(code) {
      var base = code.indexOf('clear') === 0 ? 'clear' : 'black';
      var t = TIP[code.slice(base.length)];
      return t ? t[1] : '#999';
    }
    root.querySelectorAll('[data-mh-side]').forEach(function (s) {
      s.addEventListener('click', function () { armSide = s.dataset.mhSide; syncDots(); });
    });
    if (noses.length && arms.length) {
      buildDots('nose', noses, nose);
      buildDots('arms', arms, arm);
      syncDots();
    }

    function toggle(btn, panel) {
      var on = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      panel.hidden = !on;
    }
    infoBtn.addEventListener('click', function () { toggle(infoBtn, descEl); });
    customBtn.addEventListener('click', function () { toggle(customBtn, customEl); });

    /* ---------- product view ---------- */
    function fly(fromImg, toImg) {
      if (reduce || !fromImg || !toImg || !fromImg.animate) return Promise.resolve();
      var a = fromImg.getBoundingClientRect();
      var b = toImg.getBoundingClientRect();
      if (!a.width || !b.width) return Promise.resolve();
      var c = document.createElement('img');
      c.className = 'mh__fly';
      c.src = fromImg.currentSrc || fromImg.src;
      c.style.left = b.left + 'px';
      c.style.top = b.top + 'px';
      c.style.width = b.width + 'px';
      c.style.height = b.height + 'px';
      document.body.appendChild(c);
      var s = Math.min(a.width / b.width, a.height / b.height);
      var dx = (a.left + a.width / 2) - (b.left + b.width / 2);
      var dy = (a.top + a.height / 2) - (b.top + b.height / 2);
      var anim = c.animate([
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + s + ')' },
        { transform: 'none' }
      ], { duration: 620, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)' });
      return anim.finished.catch(function () {}).then(function () { c.remove(); });
    }

    function openProduct(lineI, itemI, opts) {
      opts = opts || {};
      if (busy || !data[lineI] || !data[lineI].products[itemI]) return;
      busy = true;
      L = lineI; idx = itemI; photo = 0;
      var fromTile = opts.fromTile, fromImg = fromTile && fromTile.querySelector('img');
      var container = mode === 'line' ? sub : grid;

      var show = function () {
        container.classList.remove('is-leaving');
        if (fromTile) fromTile.classList.remove('is-picked');
        showOnly('product');
        view.classList.add('is-entering');
        window.scrollTo(0, 0);
        var pic = showPic();
        renderInfo();
        var settle = function () {
          requestAnimationFrame(function () {
            view.classList.remove('is-entering');
            busy = false;
            if (!opts.instant) closeBtn.focus({ preventScroll: true });
          });
        };
        if (opts.instant) { settle(); return; }
        (!pic.complete ? new Promise(function (r) { pic.onload = r; pic.onerror = r; setTimeout(r, 900); }) : Promise.resolve())
          .then(function () { return fly(fromImg, pic); })
          .then(settle);
      };

      if (opts.instant || reduce) { show(); return; }
      if (fromTile) fromTile.classList.add('is-picked');
      container.classList.add('is-leaving');
      setTimeout(show, 260);
    }

    /* up one level: product -> its colourway grid (or home), colourway grid -> home */
    function back() {
      if (mode === 'product') {
        if (multi(L)) { setUrl({ line: line().handle }, false); showLine(L, idx); }
        else { setUrl({}, false); showHome(L); }
      } else if (mode === 'line') {
        setUrl({}, false); showHome(L);
      }
    }

    /* ---------- events ---------- */
    grid.addEventListener('click', function (e) {
      var t = e.target.closest('[data-mh-open]');
      if (!t || busy) return;
      var i = parseInt(t.dataset.mhOpen, 10);
      if (!data[i] || !data[i].products.length) return;
      if (multi(i)) {
        setUrl({ line: data[i].handle }, true);
        if (reduce) { showLine(i); return; }
        t.classList.add('is-picked');
        grid.classList.add('is-leaving');
        busy = true;
        setTimeout(function () { grid.classList.remove('is-leaving'); t.classList.remove('is-picked'); busy = false; showLine(i); }, 260);
      } else {
        setUrl({ line: data[i].handle, item: data[i].products[0].handle }, true);
        openProduct(i, 0, { fromTile: t });
      }
    });
    subGrid.addEventListener('click', function (e) {
      var t = e.target.closest('[data-mh-item]');
      if (!t || busy) return;
      var k = parseInt(t.dataset.mhItem, 10);
      setUrl({ line: line().handle, item: line().products[k].handle }, true);
      openProduct(L, k, { fromTile: t });
    });
    $('[data-mh-back]').addEventListener('click', back);
    closeBtn.addEventListener('click', back);
    root.querySelectorAll('[data-mh-go]').forEach(function (b) {
      b.addEventListener('click', function () { go(b.dataset.mhGo); });
    });

    function route() {
      var q = new URL(location.href).searchParams;
      var li = lineIndex(q.get('line'));
      busy = false;
      if (li < 0 || !data[li].products.length) { if (mode !== 'home') showHome(); return; }
      var item = q.get('item');
      if (item || !multi(li)) {
        var k = 0;
        data[li].products.forEach(function (p, j) { if (p.handle === item) k = j; });
        openProduct(li, k, { instant: true });
      } else {
        showLine(li);
      }
    }
    window.addEventListener('popstate', route);

    document.addEventListener('keydown', function (e) {
      if (mode === 'home') return;
      if (e.target.closest && e.target.closest('input, textarea, select, cart-drawer, .menu-drawer, details[open]')) return;
      if (e.key === 'Escape') { back(); return; }
      if (mode !== 'product') return;
      var k = { ArrowUp: 'up', ArrowDown: 'down', ArrowLeft: 'left', ArrowRight: 'right' }[e.key];
      if (k) { e.preventDefault(); go(k); }
    });

    /* swipe / drag on the picture: same as the arrows */
    var sx = null, sy = null;
    stage.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; });
    stage.addEventListener('pointerup', function (e) {
      if (sx === null) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      sx = null;
      if (Math.max(Math.abs(dx), Math.abs(dy)) < 36) return;
      if (Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 'right' : 'left');
      else go(dy < 0 ? 'down' : 'up');
    });
    stage.addEventListener('pointercancel', function () { sx = null; });
    var wheelLock = 0, acc = 0, accX = 0;
    stage.addEventListener('wheel', function (e) {
      if (mode !== 'product') return;
      e.preventDefault();
      var now = Date.now();
      if (now < wheelLock) return;
      acc += e.deltaY; accX += e.deltaX;
      if (Math.abs(accX) > 60 && Math.abs(accX) > Math.abs(acc)) { go(accX > 0 ? 'right' : 'left'); }
      else if (Math.abs(acc) > 60) { go(acc > 0 ? 'down' : 'up'); }
      else return;
      acc = accX = 0;
      wheelLock = now + 550;
    }, { passive: false });

    /* ---------- add to cart ---------- */
    var addTimer = 0;
    function resetAdd() {
      clearTimeout(addTimer);
      addBtn.classList.remove('is-loading', 'is-added', 'is-shake');
    }
    function shake(el) {
      el.classList.remove('is-shake');
      void el.offsetWidth;
      el.classList.add('is-shake');
      setTimeout(function () { el.classList.remove('is-shake'); }, 450);
    }
    function bump() {
      document.querySelectorAll('#cart-icon-bubble').forEach(function (el) {
        el.classList.remove('atc-bump');
        void el.offsetWidth;
        el.classList.add('atc-bump');
      });
    }
    function waitMin(t0) {
      return new Promise(function (r) { setTimeout(r, Math.max(0, MIN_SPIN - (Date.now() - t0))); });
    }

    addBtn.addEventListener('click', function () {
      var p = product();
      if (!p || !p.available || addBtn.classList.contains('is-loading') || addBtn.classList.contains('is-added')) return;
      var variant = p.sized ? size : p.variants[0];
      if (!variant) {
        msgEl.textContent = 'Pick a size';
        shake(sizesEl);
        return;
      }
      var item = { id: variant.id, quantity: 1 };
      if (line().custom && noses.length && arms.length) {
        item.properties = { 'Nose Pad Colour': pick.nose, 'Arm Colour Left': pick.L, 'Arm Colour Right': pick.R };
      }
      var items = [item];
      if (clipRow && !clipRow.hidden && clipInput.checked) items.push({ id: clip.id, quantity: 1 });
      msgEl.textContent = '';
      var t0 = Date.now();
      addBtn.classList.add('is-loading');
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var sections = cart && cart.getSectionsToRender ? cart.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-icon-bubble'];
      fetch((window.routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items, sections: sections, sections_url: location.pathname })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          return waitMin(t0).then(function () {
            addBtn.classList.remove('is-loading');
            if (!res.ok || res.j.status) {
              msgEl.textContent = (res.j && (res.j.description || res.j.message)) || 'Could not add';
              shake(addBtn);
              return;
            }
            if (window.ATC && ATC.silent) ATC.silent(res.j);
            if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
              try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'min-home', productVariantId: variant.id, cartData: res.j }); } catch (e) {}
            }
            addBtn.classList.add('is-added');
            msgEl.textContent = 'Added';
            bump();
            addTimer = setTimeout(function () { addBtn.classList.remove('is-added'); msgEl.textContent = ''; }, HOLD);
          });
        })
        .catch(function () {
          addBtn.classList.remove('is-loading');
          msgEl.textContent = 'Could not add';
          shake(addBtn);
        });
    });

    /* deep links: ?line=handle (colourway grid) or ?line=handle&item=handle (product) */
    if (new URL(location.href).searchParams.get('line')) route();
  }

  function boot() { document.querySelectorAll('[data-mh]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
